<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <hyperkit-icon *ngIf="headerIcon" class="header-icon" color="primary" size="medium" [icon]="headerIcon"></hyperkit-icon>
      <hyperkit-typography variant="h4" align="center" color="primary">{{headerText}}</hyperkit-typography>
    </div>
    <hyperkit-icon (click)="onClose()" class="close-button" size="medium" color="inherit" icon="x"></hyperkit-icon>
  </div>
  
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
  
  <div class="dialog-actions" *ngIf="primaryButtonText || secondaryButtonText">
    <hyperkit-button
    *ngIf="secondaryButtonText" 
    (click)="onSecondaryAction()"
    color="secondary"
    [text]="secondaryButtonText"
  ></hyperkit-button>
    <hyperkit-button
    color="tertiary"
    (click)="onPrimaryAction()"
    [text]="primaryButtonText"
  ></hyperkit-button>
  </div>
</div>